$(function () {
  // $(".product-shot-gallery").on("init", function (event, slick) {
  //   $(".slick-dots button").html("&bull;");
  // });

  $(".product-shot-gallery").slick({
    arrows: true,
    dots: false,
    fade: true,
  });

  $(document).on("keydown", function (e) {
    var code = e.key ? e.key : e.which;
    if (code == 37) {
      $(".slick-arrow").each(function () {
        $(this).trigger("blur");
      });
      $(".product-shot-gallery").slick("slickPrev");
    } else if (code == 39) {
      $(".slick-arrow").each(function () {
        $(this).trigger("blur");
      });
      $(".product-shot-gallery").slick("slickNext");
    }
  });

  $("body").on("mousedown", () => {
    $(".product-shot-gallery").removeClass("md:tw-cursor-grab");
    $(".product-shot-gallery").addClass("md:tw-cursor-grabbing");
  });

  $("body").on("mouseup", () => {
    $(".product-shot-gallery").removeClass("md:tw-cursor-grabbing");
    $(".product-shot-gallery").addClass("md:tw-cursor-grab");
  });

  $("#amop-subscribe").on("click", function () {
    window._klOnsite = window._klOnsite || [];
    window._klOnsite.push(["openForm", "SHVTvb"]);
  });
});
